import React from 'react';
import { useMySubscriptions } from '../hooks/useMySubscriptions';
import { SubscriptionCard } from './SubscriptionCard';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

export const MySubscriptions: React.FC = () => {
  const { subscriptions, loading, error, refetch } = useMySubscriptions();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-destructive">Error loading subscriptions: {error}</p>
      </div>
    );
  }

  if (subscriptions.length === 0) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center">
            <p className="text-muted-foreground text-lg">No active subscriptions</p>
            <p className="text-muted-foreground text-sm mt-2">
              Subscribe to completed projects to access historical data.
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4">
        {subscriptions.map((subscription) => (
          <SubscriptionCard
            key={subscription.id}
            subscription={subscription}
            onCancelled={refetch}
          />
        ))}
      </div>
    </div>
  );
};

